import BigNumber from 'bignumber.js';
import { Address, encodeFunctionData, WalletClient } from 'viem';

import { convertToWei } from 'modules/api/utils';
import { asAddress } from 'modules/api/utils/asAddress';
import { getChain } from 'modules/api/utils/getChain';

import IERC20Abi from '../abi/IERC20';

export async function setAllowance(
  walletClient: WalletClient,
  data: {
    spender: Address;
    tokenAddress: Address;
    amount: BigNumber;
  },
) {
  const { spender, tokenAddress, amount } = data;

  const encodedData = encodeFunctionData({
    abi: IERC20Abi,
    functionName: 'approve',
    args: [spender, convertToWei(amount)],
  });

  const txHash = await walletClient.sendTransaction({
    to: asAddress(tokenAddress),
    data: encodedData,
    chain: getChain(),
    account: asAddress(walletClient.account?.address),
  });

  return txHash;
}
